module.exports = {"of":" of ","client":"Client","transaction":"Transaction #","venue":"Venue","contact":"Contact","generalAdmission":"General Admission: #","section":"Section: ","row":"Row: ","seat":"Seat: ","customer":"Customer","patron":"Patron","price":"Price","moreInfo":"More info","checkedIn":"Checked In","isDistributed":"Ticket is Distributed"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ElectronicTicket/locales/en.json
// module id = 1989
// module chunks = 0